'use strict';

// EXPORTS //

module.exports = Number.POSITIVE_INFINITY;



//////////////////
// WEBPACK FOOTER
// ./~/const-pinf-float64/lib/index.js
// module id = 1701
// module chunks = 0